import { isValidURL } from "../../../../../../helperFunctions/util";

export const useFormValidation = () => {
  const validateLink = (link) => {
    if (!link || link.length === 0) return true;
    return isValidURL(link);
  };

  const validateAnnouncementLinks = (articleLink, podcastLink, videoLink) => {
    const errors = {};

    if (articleLink && !validateLink(articleLink)) {
      errors.articleLink = "Article link should be a valid URL";
    }
    if (podcastLink && !validateLink(podcastLink)) {
      errors.podcastLink = "Podcast link should be a valid URL";
    }
    if (videoLink && !validateLink(videoLink)) {
      errors.videoLink = "Video link should be a valid URL";
    }

    return errors;
  };

  const validateEventData = ({
    isAnnouncementType,
    title,
    eventStartDate,
    eventStartTime,
    eventEndDate,
    showOnHomePageEnd,
    isLinkTicket,
    ticketId,
    ticketName,
    additionalLocations,
    checkIn,
    volunteerRequests,
    rsvpMax,
  }) => {
    const errors = {};

    // Max RSVP: optional, whole number, at most 5 digits
    if (
      rsvpMax != null &&
      rsvpMax !== "" &&
      (!Number.isInteger(Number(rsvpMax)) ||
        Number(rsvpMax) < 0 ||
        Number(rsvpMax) > 99999)
    ) {
      errors.rsvpMax = "Maximum RSVPs must be a whole number up to 5 digits";
    }

    // Title validation for announcements
    if (isAnnouncementType && (!title || title.trim() === "")) {
      errors.title = "Title is required for announcements";
    }

    // Event start date validation
    if (!eventStartDate && !isAnnouncementType) {
      errors.eventStartDate = "Event start date is required";
    }

    // Event start time validation
    if (!eventStartTime && !isAnnouncementType) {
      errors.eventStartTime = "Event start time is required";
    }

    // Show on home page end date validation
    if (eventEndDate && showOnHomePageEnd > eventEndDate) {
      errors.showOnHomePageEnd =
        "Show on home screen end date should not be after event end date";
    }

    // Ticket linking validation
    if (isLinkTicket === true && (ticketId === "" || ticketName === "")) {
      errors.ticketName = "Link proper ticket for member response";
    }

    // Location validation for check-in
    const locationCondition =
      additionalLocations
        .map(
          (locationData) =>
            !locationData ||
            !locationData?.locationData ||
            locationData?.locationData?.placeId === null ||
            locationData?.locationData?.placeId?.trim() === "",
        )
        .filter((condition) => condition).length > 0;

    if (
      checkIn?.validateGeolocation &&
      checkIn?.allowCheckin &&
      locationCondition
    ) {
      errors.location = "Location is required for event check-in";
    }

    // Season validation for check-in
    if (checkIn?.allowCheckin && !checkIn?.season) {
      errors.season = "Season is required for check-in";
    }

    // Points validation for check-in
    if (
      checkIn?.allowCheckin &&
      (!checkIn?.points || checkIn?.points.toString().trim().length === 0) &&
      !volunteerRequests?.some((req) => req.points && req.points >= 0)
    ) {
      errors.points = "Please add points to be awarded";
    }

    return errors;
  };

  return {
    validateLink,
    validateAnnouncementLinks,
    validateEventData,
  };
};
